import type { ModelLead } from '@app/api/Leads/types';
import type { LeadCardResponsibleEmployeeData } from '@app/components/LeadCard/data';

import type { LeadsRegistryAssigneeOption } from '../model/types';

export const toResponsibleEmployees = (
  options: LeadsRegistryAssigneeOption[],
  lead: ModelLead
): LeadCardResponsibleEmployeeData[] => {
  const employees = options.map(({ value, label }) => ({
    id: value,
    name: label,
  }));

  const hasCurrentResponsible =
    lead.UserId === null ||
    employees.some(({ id }) => Number(id) === lead.UserId);

  if (hasCurrentResponsible || lead.UserId === null || !lead.UserName) {
    return employees;
  }

  return [
    ...employees,
    {
      id: lead.UserId,
      name: lead.UserName,
    },
  ];
};
